import { useRef, useState, useEffect } from 'react';

export const useIsConversationActive = (): {
  isConversationActive: () => boolean;
  conversationId?: string;
  setConversationId: (value?: string) => void;
} => {
  const [conversationId, setConversationId] = useState<string>();
  const ref = useRef<string>();
  useEffect(() => {
    ref.current = conversationId;
  }, [conversationId]);
  return {
    isConversationActive() {
      return ref.current === conversationId && !!conversationId;
    },
    conversationId,
    setConversationId,
  };
};
